import { Link } from "react-router-dom";
import ContentBox from "../../../../components/atoms/ContentBox";
import Icon from "../../../../components/atoms/Icon";
import { Text } from "../../../../components/general/Text";
import {
  helpUrl,
  ImportHistoryInterface,
  renderOperationHuman,
} from "../../../../domains/ImportHistory";
import { IconImportOperation } from "../../../../features/ImportHistory/IconImportOperation";
import SectionInterface from "../../../../interfaces/SectionInterface";
import { OperationNote } from "../ImportOperation/OperationNote";
import { DownloadForm } from "./DownloadForm";
import styles from "./styles.scss";
import { UploadForm } from "./UploadForm";

export const ImportOperationForStudentPasscodeInactivationPage = (props: {
  section: SectionInterface;
  operation: ImportHistoryInterface["operation"];
}) => {
  const { section, operation } = props;

  return (
    <ContentBox className={styles.root}>
      <h2 className={styles.heading}>
        <IconImportOperation
          className="mr-6 h-[3rem] w-[3rem] text-gray-600"
          operation={operation}
        />
        {renderOperationHuman(operation)}
      </h2>
      <Text className={styles.help}>
        連携中の生徒アプリを、一括で停止することができます。操作方法を確認しながら進めてください。
        <Link to={helpUrl(operation)} rel="noopener noreferrer" target="_blank">
          <Icon name="icon-help" />
          操作方法を見る
        </Link>
      </Text>
      <OperationNote operation={operation} />
      <DownloadForm section={section} />
      <div className={styles.box}>
        <div className={styles.boxHeading}>
          <Text className={styles.boxHeadingTitle}>
            2.
            停止を希望する生徒は、ダウンロードしたCSVの「停止対象」のカラムに「停止」と記入
          </Text>
        </div>
      </div>
      <UploadForm section={section} />
    </ContentBox>
  );
};
